export const breadcrumbsConstants = [
  {
    labelKey: 'scan_doc',
    value: 'scandocument',
  },
  {
    labelKey: 'attached_docs',
    value: 'attached-documents',
  },
  {
    labelKey: 'protocol_book',
    value: 'protocolbook',
  },
  {
    labelKey: 'arch',
    value: 'archive',
  },
  {
    labelKey: 'awaiting_docs',
    value: 'awaitingDocs',
  },
  {
    labelKey: 'issued_docs',
    value: 'izdatnice',
  },
  {
    labelKey: 'stamp_collection',
    value: 'stampCollection',
  },
  {
    labelKey: 'config_menu',
    value: 'config',
  },
  {
    labelKey: 'protocol_book_permissions',
    value: 'protocol-book-permissions',
  },
  {
    labelKey: 'support.my_tickets',
    value: 'helpdesk',
  },
  {
    label: 'Admin Dashboard',
    value: 'admin-dashboard',
  },
  {
    label: 'Admin Panel',
    value: 'admin-panel',
  },
  {
    labelKey: 'logout',
    value: '',
  },
]
